import React, { useState } from 'react';
import UploadPlayers from '../components/UploadPlayers';
import UploadTeamEvent from '../components/UploadTeamEvent';
import TeamSelect from '../components/TeamSelect';

export default function UploadPage() {
  const [selectedTeamId, setSelectedTeamId] = useState('');

  return (
    <div>
      <h2>Upload Players</h2>
      <TeamSelect value={selectedTeamId} onChange={setSelectedTeamId} />
      {selectedTeamId && <UploadPlayers teamId={selectedTeamId} />}

      <h2>Upload Team Events</h2>
      {selectedTeamId && <UploadTeamEvent teamId={selectedTeamId} />}
    </div>
  );
}